/** Parse body as JSON; log non-JSON so real API errors (HTML, 502) show in console. */
export async function parseResponseAsJson(
  response: Response
): Promise<{ json: Record<string, unknown>; rawText: string }> {
  const rawText = await response.text()
  try {
    return { json: rawText ? (JSON.parse(rawText) as Record<string, unknown>) : {}, rawText }
  } catch {
    console.error('❌ [parseResponseAsJson] Resposta não é JSON', {
      status: response.status,
      statusText: response.statusText,
      rawText: rawText.slice(0, 800),
    })
    return { json: {}, rawText }
  }
}

export function logSendRejected(
  scope: string,
  response: Response,
  json: Record<string, unknown>,
  rawText: string
): void {
  console.error(`❌ [${scope}] Envio rejeitado`, {
    httpStatus: response.status,
    httpStatusText: response.statusText,
    success: json.success,
    error: json.error,
    details: json.details,
    body: rawText.length > 2000 ? `${rawText.slice(0, 2000)}…` : rawText,
  })
}
